import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Surface, Empty, TableWrap, Stat } from "@/components/app/Primitives";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { manilaToday } from "@/lib/date";

export default function ShiftRoster() {
    const [onDate, setOnDate] = useState(manilaToday());
    const [data, setData] = useState({ items: [], total: 0, unassigned: 0 });

    useEffect(() => {
        api.get("/shifts/roster", { params: { on_date: onDate } })
            .then((r) => setData(r.data)).catch(() => setData({ items: [], total: 0, unassigned: 0 }));
    }, [onDate]);

    return (
        <Surface className="p-4">
            <div className="flex items-end gap-4 mb-3">
                <div>
                    <Label>As of</Label>
                    <Input type="date" value={onDate} data-testid="roster-date"
                           onChange={(e) => setOnDate(e.target.value)} className="w-44" />
                </div>
                <Stat label="Employees" value={data.total} />
                <Stat label="Unassigned" value={data.unassigned}
                      tone={data.unassigned ? "warning" : "default"}
                      hint={data.unassigned ? "no rule reaches them" : "everyone is covered"} />
            </div>

            <TableWrap>
                <thead><tr><th>No.</th><th>Name</th><th>Position</th><th>Shift</th><th>Hours</th><th>Because</th></tr></thead>
                <tbody>
                    {data.items.map((r) => (
                        <tr key={r.employee_id} data-testid={`roster-${r.employee_no}`}>
                            <td className="font-mono text-xs">{r.employee_no}</td>
                            <td>{r.name}</td>
                            <td className="text-xs text-muted-foreground">{r.position || "—"}</td>
                            <td>{r.shift_name || <span className="text-muted-foreground">Unassigned</span>}</td>
                            <td className="font-mono text-xs">{r.shift_hours || "—"}</td>
                            <td className="text-xs text-muted-foreground">
                                {r.via ? `via ${r.via}` : "—"}{r.via_note ? ` · ${r.via_note}` : ""}
                            </td>
                        </tr>
                    ))}
                    {!data.items.length && <tr><td colSpan={6}>
                        <Empty title="No active employees" subtitle="Nothing to roster for this company." />
                    </td></tr>}
                </tbody>
            </TableWrap>
        </Surface>
    );
}
